
export const config = {
  id: 'emoji',
  name: 'Emoji',
  description: 'An emoji-rich visual style.',
  icon: 'smile-beam',
  color: 'amber', // Amber-500
  typography: "'Nunito', sans-serif",
  welcomeMessage: "👋 Hi there! I'm your friendly chatbot assistant. How can I help you today? 😊",
  preview: "This theme is perfect for creating a fun and engaging chat experience! 🌟",
  suggestedPrompts: [
    { text: 'Joke? 😂' }
  ],
  features: {
    gradients: true,
    animations: true,
    glassmorphism: true,
    emojiEffects: true
  },
  animation: {
    messageIn: 'emoji-pop',
    messageOut: 'emoji-fade',
    typing: 'emoji-typing-bounce',
    avatar: 'emoji-avatar-pulse',
    button: 'emoji-send-button',
    floatingEmojis: true
  },
  transitions: {
    duration: '0.5s',
    timing: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    hover: '0.3s ease-in-out'
  },
  effects: {
    pulse: true,
    float: true,
    shadow: 'lg',
    hover: 'scale(1.1)',
    focus: 'ring-2 ring-amber-400',
    active: 'scale-95'
  },
  emojis: {
    primary: ['😊', '🌟', '✨', '💫'],
    secondary: ['🎈', '🎉', '🌈', '💭'],
    reactions: ['👍', '❤️', '🎯', '💡']
  },
  embedCode: `<script src="chatbot-loader.js"></script>
<script>
window.chatConfig = {
  theme: "emoji",
  color: "#F59E0B",
  typography: "Nunito, sans-serif",
  welcomeMessage: "👋 Hi there! I'm your friendly chatbot assistant. How can I help you today? 😊",
  userId: "user_emoji_123",
  chatbotId: "bot_emoji_001",
  animations: {
    enabled: true,
    duration: "0.5s",
    effects: {
      floatingEmojis: true,
      reactions: true,
      pulse: true
    }
  }
};
</script>`
}; 